import { render } from "./PdfCustomInputPage.vue?vue&type=template&id=8d8fabc6&scoped=true&ts=true"
import script from "./PdfCustomInputPage.vue?vue&type=script&lang=ts"
export * from "./PdfCustomInputPage.vue?vue&type=script&lang=ts"

import "./PdfCustomInputPage.vue?vue&type=style&index=0&id=8d8fabc6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d8fabc6"]])

export default __exports__